//#region src/modules/shared/RefsByTypeTitles/constants.ts
var REFS_BY_TYPE_LABELS_MAP = {
	eventIds: {
		plural: "Events",
		single: "Event",
		type: "event"
	},
	locationIds: {
		plural: "Locations",
		single: "Location",
		type: "location"
	},
	locationLogEntryIds: {
		plural: "Log Entries",
		single: "Log Entry",
		type: "location-log-entry"
	},
	recordIds: {
		plural: "Records",
		single: "Record",
		type: "record"
	},
	reportIds: {
		plural: "Reports",
		single: "Report",
		type: "report"
	},
	userIds: {
		plural: "Users",
		single: "User",
		type: "user"
	}
};
var REFS_LINK_TYPE_LABELS_MAP = {
	event: {
		plural: "Events",
		single: "Event"
	},
	location: {
		plural: "Locations",
		single: "Location"
	},
	"location-log-entry": {
		plural: "Log Entries",
		single: "Log Entry"
	},
	record: {
		plural: "Records",
		single: "Record"
	},
	report: {
		plural: "Reports",
		single: "Report"
	},
	user: {
		plural: "Users",
		single: "User"
	}
};
var REFS_LINKS_BY_TYPE_SELECT_OPTIONS = Object.entries(REFS_LINK_TYPE_LABELS_MAP).map(([key, { single }]) => ({
	label: single,
	value: key
}));
Object.entries(REFS_BY_TYPE_LABELS_MAP).map(([key, { single }]) => ({
	label: single,
	value: key
}));
//#endregion
export { REFS_BY_TYPE_LABELS_MAP, REFS_LINKS_BY_TYPE_SELECT_OPTIONS, REFS_LINK_TYPE_LABELS_MAP };

//# sourceMappingURL=constants.js.map